import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QuotedProductControlCommunicationService {
  @Output() productId$: EventEmitter<{ productId: number, transitId: string }> = new EventEmitter();

  sendRateRequest(productId: number, transitId: string): void {
    this.productId$.emit({ productId, transitId });
  }
}
